export default {"src":"/_next/static/media/google-workspace.a5dccdf4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};